export const discount = {
    header: 'Do you have a voucher code?',
    usedVoucher: 'Redeemed voucher',
    inputLabels: {
        discountCode: 'Voucher code',
    },
    voucherIsValid: 'Voucher is valid!!',
    voucherIsNotValid: 'Voucher is invalid.',
    couldNotBeValidated: 'Sorry, this voucher code is not valid. <br/>',
    loginRequired: 'Login required',
    voucherNeedsLogin:
        'The coupon code entered is redeemable only for registered customers.<br/><br/>Please log in or register.<br/>',
    voucherMaxUsageReached: 'The maximum number of uses for the voucher code entered has been reached.',
    relativeDiscount:
        'With this voucher you get <span class="has-text-primary-dark">{value}%</span> discount.',
    absoluteDiscount:
        'With this voucher, <span class="has-text-primary-dark">{value}€</span> will be deducted at the end of your order.',
    absoluteDiscountBusinessCustomers:
        'With this voucher, <span class="has-text-primary-dark">{value}€</span> net will be deducted at the end of your order.',
    applicableXTimes:
        'This voucher is not redeemable.  | You can only use this voucher code once. | You can only use this voucher {n} times.',
    minimumOrderTotal:
        'This voucher is only valid for orders of at least <span class="has-text-primary">{amount}€</span> gültig.',
    orderGoal:
        'You still need <span class="has-text-danger">{amount} €</span> to redeem this voucher.',
    belowMinimumOrderTotal: 'Minimum order value not reached',
    freeShipping: 'We will Ship your order for free.',
    actionLabels: {
        validateCode: 'Check',
        cancel: 'Cancel',
        redeemDiscount: 'Redeem voucher',
        continueShopping: 'Continue shopping',
        tryAgain: 'Back',
        removeDiscount: 'Remove',
    },
};
